function offerAmountEstimator(loanAmountRequested, takeHomePay) {
  // let loanAmountRequested = this.$store.state.applicationData.amountAppliedFor
  // let takeHomePay = this.$store.state.applicationData.salary

  if (loanAmountRequested <= 500) {
    return loanAmountRequested
  }
  const term = 24 // would have returned already if not lifestyle requested
  const avgAPR = 0.22
  const netTakeHomePay = takeHomePay * 0.75
  const maxRepaymentPercentage = netTakeHomePay < 30000 ? 0.1 : 0.15
  let offerAmount = floor500(loanAmountRequested)
  let monthlyPayment = calculateMonthlyPaymentAmount(avgAPR, term, offerAmount, 25)
  let maxMonthlyPayment = (netTakeHomePay / 12) * maxRepaymentPercentage
  if (monthlyPayment <= maxMonthlyPayment) {
    return loanAmountRequested
  }
  while (monthlyPayment > maxMonthlyPayment) {
    offerAmount -= 500
    if (offerAmount <= 500) {
      return 500
    }
    monthlyPayment = calculateMonthlyPaymentAmount(avgAPR, term, offerAmount, 25)
  }
  return offerAmount
}

function floor500(loanAmount) {
  let remainder = loanAmount % 500
  if (remainder === 0) {
    return loanAmount
  } else {
    return loanAmount - remainder
  }
}

function calculateMonthlyPaymentAmount(interestRate, term, loanAmount, originationFee) {
  // https://www.thebalance.com/loan-payment-calculations-315564
  const principalBalance = loanAmount + originationFee
  const periodicInterestRate = interestRate / 12
  const denomNumerator = (1 + periodicInterestRate) ** term - 1
  const denomDenominator = periodicInterestRate * (1 + periodicInterestRate) ** term
  const monthlyPayment = principalBalance / (denomNumerator / denomDenominator)
  return monthlyPayment
}

module.exports.offerAmountEstimator = offerAmountEstimator
